import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Divider, Grid, Typography } from '@material-ui/core';
import KenCard from '../../../global_components/KenCard';
import KenSelect from '../../../global_components/KenSelect';
import KenButton from '../../../global_components/KenButton';
import { useTranslation } from 'react-i18next';
import KenGrid from '../../../global_components/KenGrid';

const useStyles = makeStyles((theme) => ({
  subHeaderTitle: {
    width: '100%',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '20px',
    color: '#061938',
  },
  error: {
    color: '#F14B2D',
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: 15,
    fontSize: '15px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  normal: {
    color: '#505F79',
    background: 'rgba(196, 196, 196, 0.2)',
    borderRadius: 15,
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
    fontSize: '12px',
  },
  greenText: {
    color: '#27AE60',
  },
  selectKen: {
    '& div': {
      fontSize: '12px',
    },
  },
  tableHeader: {
    padding: '6px 5px',
    backgroundColor: '#ededed',
    '&:last-child': {
      textAlign: 'center',
    },
  },
}));

function HeaderGrid(props) {
  const {
    title,
    count,
    selectStatusOptions,
    selectStatusValue,
    handleSelectStatusChange,
    selectDueInOptions,
    selectDueInValue,
    handleSelectDueInChange,
    columns,
    data,
    onViewAll,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <KenCard elevation={0}>
      <Grid
        item
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '0 15px 5px 0',
        }}
      >
        <Typography variant="h6" className={classes.subHeaderTitle}>
          {title}
        </Typography>

        {/* {selectStatusValue && (
          <Grid
            item
            xs={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
              fontSize: '12px',
            }}
          >
            <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
              Status:
            </Typography>
            <Box
              sx={{ maxWidth: 120, marginBotto {selectStatusValue && (
          <Grid
            item
            xs={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
              fontSize: '12px',
            }}
          >
            <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
              Status:
            </Typography>
            <Box
              sx={{ maxWidth: 120, marginBottom: '2px' }}
              ml={1}
              className={classes.selectKen}
            >
              <KenSelect
                options={selectStatusOptions}
                value={selectStatusValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectStatusChange}
                required
              />
            </Box>
          </Grid>
        )}m: '2px' }}
              ml={1}
              className={classes.selectKen}
            >
              <KenSelect
                options={selectStatusOptions}
                value={selectStatusValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectStatusChange}
                required
              />
            </Box>
          </Grid>
        )} */}

        {
          <Grid
            item
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '10px',
            }}
          >
            <Typography className={classes.errorText}>
              <span style={{ fontWeight: 'bold' }}>Count</span>:{count}
            </Typography>
          </Grid>
        }

        {title == 'Completed Exams'
          ? selectDueInOptions && (
              <Grid
                item
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                  width: '100%',
                }}
              >
                <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                  Completed in:
                </Typography>
                <Box
                  sx={{ maxWidth: 120, marginBottom: '2px' }}
                  ml={1}
                  className={classes.selectKen}
                >
                  <KenSelect
                    options={selectDueInOptions}
                    value={selectDueInValue}
                    dropdownColor="#FFFFFF"
                    onChange={handleSelectDueInChange}
                    required
                  />
                </Box>
              </Grid>
            )
          : selectDueInOptions && (
              <Grid
                item
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                  width: '100%',
                }}
              >
                <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                  Due in:
                </Typography>
                <Box
                  sx={{ maxWidth: 120, marginBottom: '2px' }}
                  ml={1}
                  className={classes.selectKen}
                >
                  <KenSelect
                    options={selectDueInOptions}
                    value={selectDueInValue}
                    dropdownColor="#FFFFFF"
                    onChange={handleSelectDueInChange}
                    required
                  />
                </Box>
              </Grid>
            )}

        <Grid
          item
          xs={6}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '10px',
            justifyContent: 'end',
          }}
        >
          <KenButton
            label={t('labels:View All')}
            variant="outlined"
            color="primary"
            onClick={() => onViewAll()}
          />
        </Grid>
      </Grid>
      <Divider />
      <KenGrid
        columns={columns}
        data={data}
        pagination={{ disabled: true }}
        toolbarDisabled={true}
        initialState={{
          hiddenColumns: ['id'],
        }}
        gridProps={{
          getHeaderProps: (column) => ({
            className: classes.tableHeader,
          }),
        }}
      />
    </KenCard>
  );
}

export default HeaderGrid;
